import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './GalleryDrawer.styles';
import { Drawer } from '@/components/Drawer/Drawer';
import { Button } from '@/components/UI/Button/Button';
import { CheckboxSelectedIcon } from '@/components/UI/Icons/Icons';

const imagesMock = new Array(10).fill(0);

interface CatalogueDrawerProps {
  isOpen: boolean;
  close: () => void;
  onApply: (amount: number) => void; // temporary for mocks
}

export const GalleryDrawer: React.FC<CatalogueDrawerProps> = ({
  isOpen,
  close,
  onApply,
}) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(new Set<number>());

  function apply() {
    onApply(selected.size);
    close();
  }

  function toggle(id: number) {
    setSelected(prev => {
      const newState = new Set<number>(prev);

      if (newState.has(id)) {
        newState.delete(id);
      } else {
        newState.add(id);
      }

      return newState;
    });
  }

  return (
    <Drawer
      isOpen={isOpen}
      close={close}
      title={t('pages.new_ad.choose_image_from_gallery')}
      subtitle={t('pages.new_ad.images_will_be_shown_in_search')}
    >
      <S.GalleryDrawerGrid>
        {imagesMock.map((_, i) => {
          const isSelected = selected.has(i);
          return (
            <S.GalleryDrawerItem key={i} onClick={() => toggle(i)}>
              <S.GalleryDrawerImage
                src="/images/mock-product.png"
                alt=""
                loading="lazy"
              />

              <S.GalleryDrawerCheckbox $isSelected={isSelected}>
                {isSelected && (
                  <CheckboxSelectedIcon data-testid="checkbox-selected-icon" />
                )}
              </S.GalleryDrawerCheckbox>
            </S.GalleryDrawerItem>
          );
        })}
      </S.GalleryDrawerGrid>

      <S.GalleryDrawerApply>
        <Button appearance="secondary" isFullWidth onClick={apply}>
          {t('common.apply')}
        </Button>
      </S.GalleryDrawerApply>
    </Drawer>
  );
};
